import { Component } from '@angular/core';

@Component({
  selector: 'app-page-lead',
  templateUrl: './page-lead.component.html',
  styleUrls: ['./page-lead.component.scss'],
})
export class PageLeadComponent {}
